import { render, staticRenderFns } from "./PPAInstruction.vue?vue&type=template&id=0eb96b18&scoped=true"
import script from "./PPAInstruction.vue?vue&type=script&lang=js"
export * from "./PPAInstruction.vue?vue&type=script&lang=js"
import style0 from "./PPAInstruction.vue?vue&type=style&index=0&id=0eb96b18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eb96b18",
  null
  
)

export default component.exports